(function () {
  function activateFirstVideo() {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    const slideshow = gallery.querySelector('slideshow-component');
    if (!slideshow) return;

    const slides = gallery.querySelectorAll('slideshow-slide');
    let videoIndex = -1;

    slides.forEach(function (slide, index) {
      if (videoIndex !== -1) return;
      if (
        slide.classList.contains('product-media-container--video') ||
        slide.classList.contains('product-media-container--external_video')
      ) {
        videoIndex = index;
      }
    });

    if (videoIndex === -1) return;

    slideshow.select(videoIndex);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(activateFirstVideo, 400);
    });
  } else {
    setTimeout(activateFirstVideo, 400);
  }
})();

// Add body class for gift card page
if (window.location.pathname === '/products/gift-card') {
  document.body.classList.add('page-gift-card');
}